module.exports = __webpack_public_path__ + "img/fdss.d8ae8043.jpg";